/**
 * 相对时间格式化：'刚刚' / 'N 分钟前' / 'N 小时前' / 'N 天前' / 绝对日期。
 * NOW 用 mock seed 的 epoch 作为参考，保证 demo 视觉稳定（mock 模式下）。
 */
const MOCK_EPOCH = new Date('2026-06-02T18:00:00.000Z').getTime();

export function relativeTime(iso: string, now?: number): string {
  const t = new Date(iso).getTime();
  const ref = now ?? (import.meta.env.VITE_API_MODE === 'real' ? Date.now() : MOCK_EPOCH);
  const diff = ref - t;
  if (diff < 0) return '即将';
  const min = Math.floor(diff / 60_000);
  if (min < 1) return '刚刚';
  if (min < 60) return `${min} 分钟前`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} 小时前`;
  const day = Math.floor(hr / 24);
  if (day < 14) return `${day} 天前`;
  // > 2 周：MM-DD
  const d = new Date(iso);
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${mm}-${dd}`;
}
